<template>
  <el-main>
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>行政采购项目</el-breadcrumb-item>
        <el-breadcrumb-item>项目列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="" style="margin-left: -100px;">
          <el-col :span="5">
            <el-select v-model="form.atype" placeholder="请选择类别" style="margin-right: 0; width: 100%;">
              <el-option label="行政项目名称" value="contract_name" checked></el-option>
              <el-option label="项目负责人" value="manager_name"></el-option>
              <el-option label="项目编号" value="contract_no"></el-option>
            </el-select>
          </el-col>
          <el-col :span="12" style="margin-right: 10px;">
            <el-input placeholder="请输入内容" v-model="form.key" @keyup.enter.native="search" clearable @clear="search">
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-col>
        </el-form-item>

        <el-form-item label="项目时间" prop="time">
          <el-col :span="12">
            <el-date-picker v-model="form.time" type="datetimerange" range-separator="--" start-placeholder="开始日期"
              end-placeholder="结束日期" style="margin-right: 10px;" @change="search(false)">
            </el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item label="更多" prop="type">
          <el-col :span="5" style="margin-right: 20px;">
            <el-select v-model="form.status" placeholder="选择项目状态" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <!-- <el-option label="初级" value="1"></el-option> -->
              <el-option label="未开始" value="1"></el-option>
              <el-option label="进行中" value="2"></el-option>
              <el-option label="项目终止" value="3"></el-option>
              <el-option label="已完成" value="4"></el-option>
              <el-option label="已归档" value="5"></el-option>
              <!-- <el-option label="未提交" value="6"></el-option> -->
            </el-select>
          </el-col>

          <el-col :span="5">
            <el-select v-model="form.year" placeholder="项目认列年份" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option :label="v" :value="v" v-for="(v, i) in yearList" :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="已选条件">
          <el-tag v-for="tag in tags" :key="tag.key" effect="dark" closable @close="removeTag(tag)">
            {{ tag.key }}: {{ tag.value }}
          </el-tag>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <div class="filterwrap">
        <div class="filter">
          <el-checkbox-group class="filtergroup" v-model="checkList" prop="checkList" :min="5">
            <el-checkbox label="项目编号"></el-checkbox>
            <el-checkbox label="行政项目名称"></el-checkbox>
            <el-checkbox label="预算"></el-checkbox>
            <el-checkbox label="成本"></el-checkbox>
            <el-checkbox label="剩余预算"></el-checkbox>
            <el-checkbox label="已支付"></el-checkbox>
            <el-checkbox label="未支付"></el-checkbox>
            <el-checkbox label="项目状态"></el-checkbox>
            <el-checkbox label="项目负责人"></el-checkbox>
            <el-checkbox label="项目时间"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="btnarea">
          <el-button icon="el-icon-plus" @click="link('/admin/add?mType=2')" v-if="NodeInclude('125')">新增</el-button>
          <el-button @click="exportProjectToExcel" v-if="NodeInclude('127')">导出数据</el-button>
        </div>
      </div>

      <el-table :data="itemList" border stripe style="width: 100%;" highlight-current-row>
        <el-table-column prop="contract_no" label="项目编号" header-align="center" align="center" min-width="200"
          v-if="check('项目编号')">
          <template slot-scope="scope">
            <div class="contract-no" @click="showColorPan(scope)">
              <div>
                <div class="circle">
                  <div class="circle-color" :style="{ 'background': scope.row.mark_color }"></div>
                </div>
                <div class="linkwrap normal">
                  <el-link type='primary' class="link" @click.stop="link(`/admin/view?id=${scope.row.id}&mType=2`)">{{
                    scope.row.contract_no ? scope.row.contract_no : '待填写' }}</el-link>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="contract_name" label="行政项目名称" header-align="center" min-width="300" align="center" v-if="check('行政项目名称')">
        </el-table-column>
        <el-table-column prop="showTotalBudget" label="预算" header-align="center" min-width="100" align="right" v-if="check('预算')">
        </el-table-column>
        <el-table-column prop="showTotalCost" label="成本" header-align="center" min-width="100" align="right" v-if="check('成本')">
        </el-table-column>
        <el-table-column prop="totalRemainingBudget" label="剩余预算" header-align="center" min-width="100" align="right" v-if="check('剩余预算')">
        </el-table-column>
        <el-table-column prop="totalPaidAmount" label="已支付" header-align="center" min-width="100" align="right" v-if="check('已支付')">
        </el-table-column>
        <el-table-column prop="totalNoPaidAmount" label="未支付" header-align="center" min-width="100" align="right" v-if="check('未支付')">
        </el-table-column>
        <el-table-column prop="time" label="项目时间" header-align="center" min-width="160" align="center" v-if="check('项目时间')">
          <template slot-scope="scope">
            {{ scope.row.project_start_time }} - {{ scope.row.project_end_time }}
          </template>      
        </el-table-column>              
        <el-table-column prop="status" label="项目状态" header-align="center" min-width="100" align="center" v-if="check('项目状态')">
          <template slot-scope="scope">
            <div class="circle-tag" :style="{'background': dd.pro_status_c[scope.row.status].color}">
              <div class="word">{{ dd.pro_status_c[scope.row.status].word }}</div>
            </div>
          </template> 
        </el-table-column>
        <el-table-column prop="manager_name" label="项目负责人" header-align="center" min-width="100" align="center" v-if="check('项目负责人')" />  
        <el-table-column prop="" label="操作" header-align="center" width="100" align="center" fixed="right" v-if="NodeInclude('125') || NodeInclude('126')">
          <template slot-scope="scope">
            <div class="linkwrap">
              <el-link type='primary' class="link" @click="handleClick(scope.row)" v-if="(NodeInclude('125') && scope.row.status != '5' && ( scope.row.id == '' || scope.row.is_draft == '1')) || level == 1">编辑</el-link>
              <el-link type='primary' class="link" @click="handleView(scope.row)" v-if="NodeInclude('126') && scope.row.status != '6'" >查看</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="lower" v-if="NodeInclude('128')">
        <div>预算合计：{{ total_item.budget_amount }}</div>
        <div>成本合计：{{ total_item.cost_amount }}</div>
        <div>已支付合计：{{ total_item.paid_amount }}</div>
        <div>未支付合计：{{ total_item.unpaid_amount }}</div>
        <div>
          <el-button type="primary" @click="getAdListCount()">更新合计</el-button>
        </div>
      </div>   
      <div class="apage">
        <el-pagination @current-change="handleCurrentChange" :current-page="p" :page-size="30" layout="total, prev, pager, next, jumper" :total="total"> 
        </el-pagination>
      </div>
    </div>

    <el-dialog title="选择颜色" :visible.sync="colorPanShow" width="400px">
      <div class="color-pan">
        <ul>
          <li @click="markProjectColor(i.color)" v-for="i, d in dd.color_pan" :key="`color${d}`"
            :style="{ 'background': i.color }">
            <span v-if="i.color == colorData.color"><i class="el-icon-close"></i></span>
            <span v-else><i class="el-icon-check"></i></span>
          </li>
        </ul>
      </div>
    </el-dialog>    
  </el-main>
</template>

<script>
// CodeToText
import * as api from '@/api'
import {thousands} from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'custom',
  data() {
    return {
      nodeLimtList: [],
      level: 0,
      checkList: [
        '项目编号',
        '行政项目名称',
        '预算',
        '成本',
        '剩余预算',
        '已支付',
        '未支付',
        '项目状态',
        '项目负责人',
        '项目时间',
      ],
      yearList:[],
      itemList: [],
      total: 0,
      perPage: 30,
      p: 1,
      form: {
        key: '',
        atype: 'contract_name',
        time: ['', ''],
      },
      colorPanShow: false,
      colorData: {},
      total_item: {},
    }
  },
  computed: {
    tags() {
      let temp = [
        {
          key: this.dd.adminType[this.form.atype],
          val: 'atype',
          value: this.form.key,
          active: !!this.form.atype && !!this.form.key,
        },
        {
          key: '项目时间',
          val: 'time',
          value: this.dateValue(this.form.time),
          active: !!this.form.time && this.form.time[0] && !!this.form.time && this.form.time[1],
        },
        {
          key: '项目状态',
          val: 'status',
          value: this.dd.pro_status[this.form.status],
          active: !!this.form.status,
        }, 
        {
          key: '认列年份',
          val: 'year',
          value: this.form.year,
          active: !!this.form.year,
        }, 
      ]
      temp = temp.filter((item) => item.active)
      return temp
    },
  },
  created() {
    var date = new Date()
    var year = date.getFullYear() + 1
    this.getYearList(year);
  },
  mounted() {
    this.getStoreFn()
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    exportProjectToExcel() {
      window.location = api.exportProjectToExcel({
        ...this.form,
        contract_start_time: this.fdate(this.form.time[0]) || '',
        contract_end_time: this.fdate(this.form.time[1]) || '',
        mType: '2',
      })
    },

    dateValue(dateArr) {
      if (Array.isArray(dateArr)) {
        return this.fdate(dateArr[0]) + '-' + this.fdate(dateArr[1])
      } else {
        return ''
      }
    },

    check(key) {
      return this.checkList.includes(key)
    },

    link(url) {
      this.$router.push(url)
    },

    getYearList(y) {
      for (let i = 2021; i <= y; i++) {
        this.yearList.push(i)
      }
    },

    handleClick(item) {
      this.$router.push({
        path: '/admin/add',
        query: { id: item.id, mType: '2', },
      })
      
    },

    handleView(item) {
      this.$router.push({
        path: '/admin/view',
        query: { id: item.id, mType: '2', },
      })
    },

    search() {
      this.p = 1
      store.commit('setAdData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },

    getStoreFn() {
      this.form = Object.keys(store.state.adData).length != 0 ? store.state.adData : this.form
      this.getList()
    },

    getList() {
      this.checkUrlFn()
      this.checkNodeFn('61')
      const time = this.form.time || []
      const postData = {
        ...this.form,
        p: this.p,
        per_page: this.perPage,
        contract_start_time: this.fdate(time[0]),
        contract_end_time: this.fdate(time[1]),
        [this.form.atype]: this.form.key,//搜索
        mType: '2',
      }
      api.getAdminProjectList(postData).then((res) => {
        this.itemList = res.itemList
        this.itemList = this.itemList.map((item)=>{
          item.contract_amount = thousands(Number(item.contract_amount))//合同金额
          item.totalBudget = thousands(Number(item.totalBudget))//预算
          item.showTotalBudget = isNaN(item.showTotalBudget) ? item.showTotalBudget : thousands(Number(item.showTotalBudget))//预算
          item.totalCost = thousands(Number(item.totalCost))//成本
          item.showTotalCost = isNaN(item.showTotalCost) ? item.showTotalCost : thousands(Number(item.showTotalCost))//预算
          item.totalFinishedInvoice = thousands(Number(item.totalFinishedInvoice))//已开票
          item.totalUnFinishedInvoice = thousands(Number(item.totalUnFinishedInvoice))//未开票
          item.totalPaidAmount = thousands(Number(item.totalPaidAmount))//已支付
          item.totalNoPaidAmount = thousands(Number(item.totalNoPaidAmount))//未支付
          item.totalReceivedAmount = thousands(Number(item.totalReceivedAmount))//已收款
          item.totalUnReceivedAmount = thousands(Number(item.totalUnReceivedAmount))//未收款
          item.totalInvoiceUnReceive = thousands(Number(item.totalInvoiceUnReceive))//已开票未收款
          return item
        })
        this.total = +res.totalNum
        setTimeout(() => {
          //权限
          this.level = store.state.level
        }, 200);
        console.log(this.level);
      })
    },
    getAdListCount () {
      const time = this.form.time || []
      const postData = {
        ...this.form,
        p: this.p,
        per_page: this.perPage,
        contract_start_time: this.fdate(time[0]),
        contract_end_time: this.fdate(time[1]),
        [this.form.atype]: this.form.key,//搜索
        mType: '2',
      }
      api.getAdListCount(postData).then((res) => {
        console.log('change');
        this.total_item = res.total_item
        this.total_item.budget_amount = thousands(Number(this.total_item.budget_amount))
        this.total_item.cost_amount = thousands(Number(this.total_item.cost_amount))
        this.total_item.paid_amount = thousands(Number(this.total_item.paid_amount))
        this.total_item.unpaid_amount = thousands(Number(this.total_item.unpaid_amount))
      })
    },
    removeTag(tag) {
      if (tag.val === 'time') {
        this.form.time = ['', '']
      }
      !{
        type: () => {
          this.form['key'] = undefined
        },
      }[tag.val]?.()
      this.form[tag.val] = ''
      this.form.key = this.form.atype == '' ? '' : this.form.key 
      store.commit('setAdData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
      console.log(tag)
    },
    handleCurrentChange(p) {
      this.p = p
      
      store.commit('setAdData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },
    showColorPan({ row }) {
      if (!this.NodeInclude('129')) {
        return false
      }
      const index = this.itemList.indexOf(row)
      this.colorData = {
        project_id: row.id,
        mType: 2,
        color: row.mark_color,
        id: row.markArr?.id,
        option: row.markArr?.id ? '2' : '1',
        index: index,
      }
      this.colorPanShow = true
    },
    markProjectColor(color) {
      const index = this.colorData.index
      const postData = {
        ...this.colorData,
        mark_color: color == this.colorData.color ? '' : color, //同色取消
      }
      delete postData.color
      delete postData.index
      api.markProjectList(postData).then(() => {
        this.colorPanShow = false
        this.itemList[index].mark_color = color == this.colorData.color ? '' : color //同色取消
        // this.getList()
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.filterwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 0 20px 0;
  .filter {
    width: 85%;
  }
  .btnarea {
    box-sizing: border-box;
    width: 15%;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.el-checkbox-group.filtergroup .el-checkbox {
  width: auto;
}

.apage {
  background: #f2f2f2;
  padding: 8px;
  text-align: right;
}

.el-select {
  margin-right: 20px;
}

.el-tag {
  margin-right: 20px;
  height: 36px;
  line-height: 36px;
  border: none;
}

.form {
  @extend %box;
  padding: 30px;
  margin-bottom: 20px;
}

.table {
  @extend %box;
  padding: 30px;
}

.lower {
  @extend %start;
  padding: 20px 0;
  font: 600 14px/20px $font;

  >div {
    margin-right: 15px;
  }
}

.linkwrap {
  font-size: 12px;
  &.normal {
    color: #606266;
    a {
      color: #606266;
      &:hover {
        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }
      >span {
        font-size: 12px;
        color: #606266;
      }
    }
  }
}

.contract-no {
  width: 100%;
  text-align: center;
  cursor: pointer;
  position: relative;

  >div {

    display: inline-flex !important;
    @extend %start;

    .circle {
      width: 12px;
      height: 12px;
      margin-right: 10px;
      cursor: pointer;
      position: absolute;
      top: 50%;
      left: 5px;
      transform: translateY(-50%);

      .circle-color {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        position: absolute;
        left: 0;
      }
    }
  }
}

.color-pan {
  width: 100%;
  background: #fff;

  >ul {
    @extend %start;
    flex-flow: row wrap;

    li {
      @extend %center;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      margin: 0 20px 20px 0;
      cursor: pointer;

      span {
        display: none;
        color: #fff;
      }

      &:hover {
        span {
          display: block;
        }
      }
    }
  }
}
</style>
